import React from 'react';

const ItemInfoCliente = ({ese}) => {
  /*
  *
  * ,"isSolCliente":false,"id_usuario_cliente_solicitado
  * comcliente
  *
  * */
  return (
    <>
      {ese.isSolCliente ? <div className="m10B"><i className="fa fa-check"/> Solicitado por cliente</div> : null}
      {ese.comCliente ? <div><i className="fa fa-comment"/> {ese.comCliente}</div> : null}
    </>
  );
};

export default ItemInfoCliente